/**
 * External dependencies
 */
import React from 'react';
import { Stack, Text, Box } from '@towersystems/towersystems-design-system';
import Skeleton from 'react-loading-skeleton';

/**
 * Internal dependencies
 */
import Card from 'components/card';

const Loader = () => {
    return (
        <Stack space='large'>
            <Skeleton width={500} />
            <Skeleton width={500} />
            <Skeleton width={500} />
        </Stack>
    );
};

export default Loader;
